/* unplugin-vue-components disabled */import { render } from "./goTop.vue?vue&type=template&id=06a681eb"
import script from "./goTop.vue?vue&type=script&lang=js"
export * from "./goTop.vue?vue&type=script&lang=js"

import "./goTop.vue?vue&type=style&index=0&id=06a681eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__